(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list-new/assets/javascripts/column-components/game-status.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list-new/assets/javascripts/column-components/game-status.js');

'use strict';

const getStatusDesc = svs.components.marketplace.helpers.games.getStatusDesc;
const _svs$components$marke = svs.components.marketplaceData.gamesConstants,
  GAME_STATUS_DRAW_CLOSED = _svs$components$marke.GAME_STATUS_DRAW_CLOSED,
  GAME_STATUS_SUBMITTABLE = _svs$components$marke.GAME_STATUS_SUBMITTABLE,
  GAME_STATUS_SUBMITTED = _svs$components$marke.GAME_STATUS_SUBMITTED,
  GAME_STATUS_NOT_ENOUGH_SOLD = _svs$components$marke.GAME_STATUS_NOT_ENOUGH_SOLD,
  GAME_STATUS_SOLD_OUT = _svs$components$marke.GAME_STATUS_SOLD_OUT;
const GameStatus = _ref => {
  let status = _ref.status,
    _ref$hasPermissionToS = _ref.hasPermissionToSubmit,
    hasPermissionToSubmit = _ref$hasPermissionToS === void 0 ? false : _ref$hasPermissionToS,
    _ref$hasPreliminaryRo = _ref.hasPreliminaryRow,
    hasPreliminaryRow = _ref$hasPreliminaryRo === void 0 ? false : _ref$hasPreliminaryRo,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  if (!status) {
    return null;
  }
  const statusText = getStatusDesc(status, hasPermissionToSubmit, hasPreliminaryRow);
  if (!statusText) {
    return null;
  }

  const isRedStatus = [GAME_STATUS_SUBMITTED, GAME_STATUS_SUBMITTABLE, GAME_STATUS_DRAW_CLOSED, GAME_STATUS_NOT_ENOUGH_SOLD, GAME_STATUS_SOLD_OUT].includes(status);
  const colorClass = isRedStatus ? 'fc-red' : 'fc-grey-600';
  const combinedClassName = "".concat(colorClass, " ").concat(className).trim();
  return React.createElement("div", {
    className: combinedClassName
  }, statusText);
};
setGlobal('svs.components.marketplace.gameListNew.columnComponents.GameStatus', GameStatus);

 })(window);